import axiosHttpClient from "../axiosHttpClient";

export function post(data: any) {
	return axiosHttpClient.post('/environment-class', data);
}

export function getAll() {
	return axiosHttpClient.get('/environment-classes');
}

export function getOne(id: number) {
	return axiosHttpClient.get('/environment-class/one/'+id.toString());
}

export function deleteAllowed(id: number) {
	return axiosHttpClient.get('/environment-class/delete-allowed/'+id.toString());
}

export function remove(id: number) {
	return axiosHttpClient.get('/environment-class/delete/'+id.toString());
}

